import { render } from "./EditParametroView.vue?vue&type=template&id=60cff332&scoped=true"
import script from "./EditParametroView.vue?vue&type=script&lang=js"
export * from "./EditParametroView.vue?vue&type=script&lang=js"

import "./EditParametroView.vue?vue&type=style&index=0&id=60cff332&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cff332"]])

export default __exports__